import { Pipe, PipeTransform } from '@angular/core';
import { EntityField } from '../../../services/entities/entity-type.class';
import { EntityFormField, PheFormData } from '../../../services/entity-type.service';

export interface TableFieldColumn {
    field: EntityFormField;
    colSpan: number;
}

@Pipe({
    name: 'orderTableFields',
})
export class OrderTableFieldsPipe implements PipeTransform {
    /**
     * A row's own entity type can miss fields (columns) that other entity types in the same
     * table do have, e.g. `truck` has one field less than `wiper`. Missing columns leave gaps
     * in `tableHeader` for this row, so each field is given a `colSpan` that stretches it up to
     * (but not including) the next field this row actually has, absorbing any gap in between.
     */
    transform(pheFormData: PheFormData, tableHeader: EntityField[]): TableFieldColumn[] {
        // `field.key` on the Map's values isn't reliably set (createPheFormGroup never assigns it),
        // so the Map's own keys - always correct, set when the entry was added - are used instead.
        const entries = [...pheFormData.phe.entries(), ...pheFormData.pheData.entries()].sort(
            ([, a], [, b]) => a.displayOrder - b.displayOrder
        );
        const headerKeys = tableHeader.map(header => header.key);

        const columns: TableFieldColumn[] = entries.map(([key, field], index) => {
            const fieldIndex = headerKeys.indexOf(key);
            const nextKey = index + 1 < entries.length ? entries[index + 1][0] : null;
            const nextFieldIndex = nextKey !== null ? headerKeys.indexOf(nextKey) : headerKeys.length;
            return { field, colSpan: nextFieldIndex - fieldIndex };
        });

        const leadingGap = entries.length ? headerKeys.indexOf(entries[0][0]) : headerKeys.length;
        if (leadingGap > 0) {
            columns.unshift({ field: null, colSpan: leadingGap });
        }

        return columns;
    }
}
